import faqQuestion      from './faq-question';

/**
 *
 */

function faqCategory(el, faq, model, app) {
    
    const questions = [];

    /**
     *
     */
    const render = function() {
        self.$el = $(faq.tmplCategory.render(model));

        // bind child items
        // we assume the index of the element matches
        // the json index, could be nicer though.
        self.$el.find('[data-js-faq-show-category]').click(togglerClicked);
        self.$el
            .find('[data-js-faq-question]')
            .each((i, el) => {
                let question = faqQuestion(el, faq, model.questions[i], app);
                questions.push(question);
            });

        return self;
    };

    const remove = function() {
        questions.forEach((question) => question.unbindEvents());
        self.$el.remove();
    };

    const togglerClicked = function(evt) {
        evt.preventDefault();
        if (!model || !model.id) { return; }
        faq.setParams({
            category: model.id,
            query: undefined,
            commonSearch: undefined,
            question: undefined
        });
    };

    let self = {
        remove,
        render
    };

    return self;
};

export default faqCategory;
